/// <amd-module name="Tfs/Charting/RestClient/Reporting" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\client\charting\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Reporting from "../Contracts/Reporting";

export interface IReportingRestClient extends IVssRestClient {
    /**
     * @param chartConfiguration - 
     * @param project - Project ID or project name
     */
    createChartConfiguration(chartConfiguration: Reporting.ChartConfiguration, project: string): Promise<Reporting.ChartConfigurationResponse>;
    /**
     * @param project - Project ID or project name
     * @param id - 
     */
    deleteChartConfiguration(project: string, id: string): Promise<void>;
    /**
     * @param project - Project ID or project name
     * @param id - 
     */
    getChartConfiguration(project: string, id: string): Promise<Reporting.ChartConfigurationResponse>;
    /**
     * @param project - Project ID or project name
     * @param scope - 
     * @param groupKey - 
     */
    getChartConfigurations(project: string, scope: string, groupKey: string): Promise<Reporting.ChartConfigurationResponse[]>;
    /**
     * @param chartConfiguration - 
     * @param project - Project ID or project name
     */
    replaceChartConfiguration(chartConfiguration: Reporting.ChartConfiguration, project: string): Promise<Reporting.ChartConfigurationResponse>;
    /**
     * @param scope - 
     */
    getDataServiceCapabilities(scope: string): Promise<Reporting.DataServiceCapabilitiesResponse>;
    /**
     * Runs a request to collect and tabulate data described in the transformOptions for viewing.
     * 
     * @param transformOptions - A description of the data to be queried.
     * @param project - Project ID or project name
     * @param scope - The feature scope to be queried.
     */
    runTransformQuery(transformOptions: Reporting.TransformOptions[], project: string, scope: string): Promise<Reporting.TransformResult[]>;
}

class ReportingRestClient extends RestClientBase implements IReportingRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param chartConfiguration - 
     * @param project - Project ID or project name
     */
    public async createChartConfiguration(
        chartConfiguration: Reporting.ChartConfiguration,
        project: string
        ): Promise<Reporting.ChartConfigurationResponse> {

        return this.beginRequest<Reporting.ChartConfigurationResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/reporting/ChartConfiguration/{id}",
            routeValues: {
                project: project
            },
            body: chartConfiguration
        });
    }

    /**
     * @param project - Project ID or project name
     * @param id - 
     */
    public async deleteChartConfiguration(
        project: string,
        id: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/reporting/ChartConfiguration/{id}",
            routeValues: {
                project: project,
                id: id
            }
        });
    }

    /**
     * @param project - Project ID or project name
     * @param id - 
     */
    public async getChartConfiguration(
        project: string,
        id: string
        ): Promise<Reporting.ChartConfigurationResponse> {

        return this.beginRequest<Reporting.ChartConfigurationResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/reporting/ChartConfiguration/{id}",
            routeValues: {
                project: project,
                id: id
            }
        });
    }

    /**
     * @param project - Project ID or project name
     * @param scope - 
     * @param groupKey - 
     */
    public async getChartConfigurations(
        project: string,
        scope: string,
        groupKey: string
        ): Promise<Reporting.ChartConfigurationResponse[]> {

        const queryValues: any = {
            scope: scope,
            groupKey: groupKey
        };

        return this.beginRequest<Reporting.ChartConfigurationResponse[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/reporting/ChartConfiguration/{id}",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * @param chartConfiguration - 
     * @param project - Project ID or project name
     */
    public async replaceChartConfiguration(
        chartConfiguration: Reporting.ChartConfiguration,
        project: string
        ): Promise<Reporting.ChartConfigurationResponse> {

        return this.beginRequest<Reporting.ChartConfigurationResponse>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "{project}/_apis/reporting/ChartConfiguration/{id}",
            routeValues: {
                project: project
            },
            body: chartConfiguration
        });
    }

    /**
     * @param scope - 
     */
    public async getDataServiceCapabilities(
        scope: string
        ): Promise<Reporting.DataServiceCapabilitiesResponse> {

        return this.beginRequest<Reporting.DataServiceCapabilitiesResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/reporting/DataServiceCapabilities/{scope}",
            routeValues: {
                scope: scope
            }
        });
    }

    /**
     * Runs a request to collect and tabulate data described in the transformOptions for viewing.
     * 
     * @param transformOptions - A description of the data to be queried.
     * @param project - Project ID or project name
     * @param scope - The feature scope to be queried.
     */
    public async runTransformQuery(
        transformOptions: Reporting.TransformOptions[],
        project: string,
        scope: string
        ): Promise<Reporting.TransformResult[]> {

        return this.beginRequest<Reporting.TransformResult[]>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/reporting/TransformQuery/{scope}",
            routeValues: {
                project: project,
                scope: scope
            },
            body: transformOptions
        });
    }

}

export const ReportingClientName = "IReportingRestClient";

export function getReportingClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IReportingRestClient {
    return pageContext.getRestClient<IReportingRestClient>(ReportingClientName, options);
}

RestClients.add(ReportingClientName, { 
    factory: ReportingRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
